import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

const reputationItems = [
  {
    name: '动漫达人小王',
    avatar: 'ri-user-star-line',
    comment: '樱花动漫之家是我每天必用的动漫网站，界面简洁好看，手机上追番特别方便。资源更新速度也很快，强烈推荐！',
    rating: 5,
    date: '2026-07-25',
  },
  {
    name: '追番少女小琳',
    avatar: 'ri-user-heart-line',
    comment: '用了很多动漫网站，樱花动漫之家的体验是最好的。分类清晰，推荐精准，让我发现了很多宝藏番剧。',
    rating: 5,
    date: '2026-07-18',
  },
  {
    name: '资深漫迷老张',
    avatar: 'ri-user-smile-line',
    comment: '作为一个看了十几年动漫的老粉，我对动漫网站的要求很高。樱花动漫之家无论是内容质量还是用户体验都让我非常满意。',
    rating: 5,
    date: '2026-07-10',
  },
  {
    name: '二次元爱好者阿杰',
    avatar: 'ri-user-voice-line',
    comment: '网站的手机适配做得太好了，通勤路上随时追番。希望樱花动漫之家越来越好，推出更多精彩内容！',
    rating: 5,
    date: '2026-06-28',
  },
];

const faqItems = [
  {
    q: '樱花动漫之家上的动漫资源是免费的吗？',
    a: '是的，樱花动漫之家上的所有动漫资源均免费在线观看，无需注册或付费。我们致力于为广大动漫爱好者提供便捷、免费的动漫观看体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '樱花动漫之家专注手机动漫体验，完美适配iOS和Android等移动设备。同时也支持电脑端访问，无论使用什么设备，都能获得流畅的观看体验。',
  },
  {
    q: '动漫资源更新频率如何？',
    a: '我们与日本播出时间同步更新，一般当天即可上线最新话。热门动漫通常在播出后数小时内即可在樱花动漫之家观看。',
  },
  {
    q: '如何找到我想看的动漫？',
    a: '您可以通过首页的搜索功能直接搜索动漫名称，也可以通过分类导航按类型、地区、年份等维度筛选，快速找到感兴趣的动漫作品。',
  },
  {
    q: '网站有广告吗？会影响观看体验吗？',
    a: '樱花动漫之家始终坚持用户体验优先原则，广告投放非常克制，不会出现弹窗或强制视频广告，确保您流畅观看动漫。',
  },
];

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-3" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              关于樱花动漫之家
            </h1>
          </div>
        </div>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl font-heading text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              品牌介绍
            </h2>
            <div className="prose max-w-none">
              <p className="text-foreground-700 leading-relaxed mb-4">
                <strong className="text-foreground-950">樱花动漫之家</strong>成立于2020年，是一个专注于手机动漫观看的门户网站。我们致力于为广大动漫爱好者提供最便捷、最高质量的在线动漫观看服务，让每一个人都能随时随地通过移动设备欣赏到自己喜爱的动漫作品。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                我们的团队由一群热爱动漫的年轻人组成，深刻理解动漫爱好者的需求和痛点。从网站设计到内容策划，每一个环节都融入了我们对动漫的热爱与执着。我们相信，优秀的动漫体验不应该受限于设备和时间。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                经过多年的发展，<strong className="text-foreground-950">樱花动漫之家</strong>已经积累了超过10,000部动漫资源，涵盖热血、恋爱、奇幻、搞笑、战斗、悬疑、日常、科幻、冒险、校园等多种类型，覆盖日本动漫、国漫、欧美动漫等多个地区。平台日活跃用户超过50万，用户好评率高达99.7%。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10">
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-smartphone-line text-xl text-primary-600"></i>
                </div>
                <div className="text-2xl font-bold text-foreground-950 mb-1">10,000+</div>
                <div className="text-sm text-foreground-600">动漫资源</div>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-user-line text-xl text-accent-700"></i>
                </div>
                <div className="text-2xl font-bold text-foreground-950 mb-1">50万+</div>
                <div className="text-sm text-foreground-600">日活跃用户</div>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-thumb-up-line text-xl text-secondary-700"></i>
                </div>
                <div className="text-2xl font-bold text-foreground-950 mb-1">99.7%</div>
                <div className="text-sm text-foreground-600">用户好评率</div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl font-heading text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              我们的优势
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="bg-background-50 rounded-lg p-5 border border-secondary-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-3">
                  <i className="ri-speed-up-line text-lg text-primary-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-2">极速更新</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">与日本播出时间同步更新，热门动漫当天即可观看，绝不让你错过任何一集精彩内容。</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 border border-secondary-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-3">
                  <i className="ri-smartphone-line text-lg text-accent-700"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-2">移动优先</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">专为手机用户打造的观看体验，流畅的触控操作和适配各种屏幕尺寸，随时随地追番。</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 border border-secondary-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 mb-3">
                  <i className="ri-shield-check-line text-lg text-secondary-700"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-2">高清画质</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">提供1080P高清动漫资源，让你在手机上也能享受影院级的画质体验，每一帧都清晰动人。</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 border border-secondary-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-3">
                  <i className="ri-heart-line text-lg text-primary-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-2">完全免费</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">所有动漫资源均免费在线观看，无需注册、无需付费。我们相信好的动漫应该让每个人都能看到。</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl font-heading text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {reputationItems.map((item, idx) => (
                <div key={idx} className="bg-background-100 rounded-lg p-5 border border-secondary-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                      <i className={`${item.avatar} text-lg text-primary-600`}></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">{item.name}</div>
                      <div className="text-xs text-foreground-500">{item.date}</div>
                    </div>
                    <div className="ml-auto flex items-center gap-0.5">
                      {Array.from({ length: item.rating }).map((_, i) => (
                        <div key={i} className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-star-fill text-xs text-accent-500"></i>
                        </div>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.comment}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl font-heading text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              常见问题
            </h2>
            <div className="space-y-3">
              {faqItems.map((item, idx) => (
                <details key={idx} className="group bg-background-50 rounded-lg border border-secondary-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-950 pr-4">{item.q}</span>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:hidden"></i>
                      <i className="ri-arrow-up-s-line text-foreground-500 hidden group-open:block"></i>
                    </div>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl font-heading text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-lg p-5 border border-secondary-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">电子邮箱</h3>
                <a href="mailto:contact@yinghuadongman.com" className="text-xs text-primary-500 hover:text-primary-600 break-all cursor-pointer" rel="nofollow">
                  contact@yinghuadongman.com
                </a>
              </div>
              <div className="bg-background-100 rounded-lg p-5 border border-secondary-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-xl text-accent-700"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-600">樱花动漫之家</p>
              </div>
              <div className="bg-background-100 rounded-lg p-5 border border-secondary-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-weibo-line text-xl text-secondary-700"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1">官方微博</h3>
                <a href="#" className="text-xs text-primary-500 hover:text-primary-600 cursor-pointer" rel="nofollow">
                  @樱花动漫之家
                </a>
              </div>
            </div>
          </div>
        </section>

        <script type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "name": "关于樱花动漫之家",
              "description": "樱花动漫之家是专注手机动漫的门户网站，提供海量免费动漫在线观看。成立于2020年，拥有超过10,000部动漫资源。",
              "url": "https://www.yinghuadongman.com/about",
              "about": {
                "@type": "Organization",
                "name": "樱花动漫之家",
                "url": "https://www.yinghuadongman.com/",
                "description": "樱花动漫之家让您在线免费观看动漫，专注手机用户，随时随地欣赏各种动漫作品。"
              }
            })
          }}
        />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": faqItems.map(item => ({
                "@type": "Question",
                "name": item.q,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": item.a
                }
              }))
            })
          }}
        />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.yinghuadongman.com/" },
                { "@type": "ListItem", "position": 2, "name": "关于我们" }
              ]
            })
          }}
        />
      </main>
      <Footer />
    </>
  );
}